export class CstLocationNotes {
    Id: number;
    ClientId: number;
    ServiceLocationId: number;
    Notes: string;
}